module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0094.jpg?v=7b7fa039";